import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import ChargeDossiersModal from '../../../components/management/AuxModals/ChargeDossiersModal'
import { openChargeDossiersModal, closeChargeDossiersModal, updateChargeDossiersModal } from '../../../actions/management/auxModals/auxModals'
import { fetchSaleTypeBySubtype, fetchOperationType, fetchSalesman, fetchSaleTypeByOperationType } from '../../../actions/combos/combos'
import { setFleetChargeDossiersProcess } from '../../../actions/unattendedProcess/unattendedProcess'
import { fetchTemplateFile } from '../../../actions/masters/masters'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.chargeDossiersModal,
    combos: state.combos,
    paymentMethodCombo: state.management.paymentCombo
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openChargeDossiersModal,
      closeChargeDossiersModal,
      fetchSaleTypeBySubtype,
      fetchOperationType,
      setFleetChargeDossiersProcess,
      updateChargeDossiersModal,
      fetchSalesman,
      fetchSaleTypeByOperationType,
      fetchTemplateFile
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ChargeDossiersModal))
